/*
    Copyright 2023 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import type { SpanAttributes, SpanAttributeValue } from "@opentelemetry/api";

// This module exists to maintain backwards compatibility to older OTel versions.

// The SpanEmbedder module is indirectly exposing these types outside of the package so to maintain
// backwards compatibility with older OTel versions we are using the old/deprecated types here.
// eslint-disable-next-line @typescript-eslint/no-deprecated -- Api 1.0.0 compat
export type Attributes = SpanAttributes;
// eslint-disable-next-line @typescript-eslint/no-deprecated -- Api 1.0.0 compat
export type AttributeValue = SpanAttributeValue;
